import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "comment-write bg-lightgray p-12 my-2 d-flex align-items-center" }
const _hoisted_2 = { class: "comment-form" }
const _hoisted_3 = { class: "input-group custom-search" }
const _hoisted_4 = ["v-for"]
const _hoisted_5 = ["disabled", "id", "placeholder"]
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_profile_picture = _resolveComponent("user-profile-picture")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_user_profile_picture, {
      cssClass: "user-icon",
      userEmail: _ctx.me.email,
      userName: _ctx.me.vorname + '' + _ctx.me.nachname
    }, null, 8, ["userEmail", "userName"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", {
          "v-for": _ctx.textFieldId,
          class: "sr-only"
        }, "Neuen Kommentar verfassen", 8, _hoisted_4),
        _withDirectives(_createElementVNode("textarea", {
          disabled: _ctx.disabled,
          id: _ctx.textFieldId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.kommentarText) = $event)),
          type: "text",
          rows: "1",
          class: "form-control custom-search-input w-100",
          placeholder: _ctx.placeholderText,
          onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkInputLength())),
          ref: "commentTa",
          style: _normalizeStyle(_ctx.inputStyle)
        }, null, 44, _hoisted_5), [
          [_vModelText, _ctx.kommentarText]
        ]),
        _withDirectives(_createElementVNode("textarea", {
          class: "shadowTA",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.kommentarText) = $event)),
          ref: "shadow",
          tabindex: "0"
        }, null, 512), [
          [_vModelText, _ctx.kommentarText]
        ]),
        _createElementVNode("button", {
          class: "btn btn-suche bg-white custom-search-button btn-textarea-search",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitComment && _ctx.submitComment(...args))),
          disabled: _ctx.sendButtonDisabled
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("i", { class: "fas fa-paper-plane f-24 text-azure" }, null, -1),
          _createElementVNode("span", { class: "sr-only" }, "Kommentar senden", -1)
        ]))], 8, _hoisted_6)
      ])
    ])
  ]))
}